import { defineNuxtPlugin } from '#app'
import type Inputmask from 'inputmask'

/**
 * Директива v-mask с ленивой загрузкой Inputmask.
 *
 * Библиотека (~100 KB min) раньше сидела в entry-бандле каждой страницы,
 * хотя маски используются только в формах ЛК и Form/Field с пропом mask.
 * Теперь чанк inputmask грузится при первом монтировании элемента
 * с непустым значением директивы.
 */

let inputmaskPromise: Promise<typeof Inputmask> | null = null

function loadInputmask(): Promise<typeof Inputmask> {
    if (!inputmaskPromise) {
        inputmaskPromise = import('inputmask').then(({ default: InputmaskLib }) => {
            InputmaskLib.extendAliases({
                'number': {
                    rightAlign: true,
                    mask: '9{*}'
                }
            });
            InputmaskLib.extendAliases({
                'price': {
                    rightAlign: true,
                    suffix: ' ₽',
                    mask: '9{*} ₽'
                }
            });
            InputmaskLib.extendAliases({
                'priceLeft': {
                    rightAlign: false,
                    showMaskOnHover: false,
                    suffix: ' ₽',
                    mask: '9{*} ₽'
                }
            });
            InputmaskLib.extendAliases({
                'numberLeft': {
                    rightAlign: false,
                    mask: '9{*}'
                }
            });
            InputmaskLib.extendAliases({
                'hoursLeft': {
                    rightAlign: false,
                    showMaskOnHover: false,
                    suffix: ' ч',
                    mask: '9{*} ч',
                },
            });
            InputmaskLib.extendAliases({
                'durationLeft': {
                    rightAlign: false,
                    showMaskOnHover: false,
                    suffix: ' мин',
                    mask: '9{*} мин',
                },
            });
            return InputmaskLib
        })
    }
    return inputmaskPromise
}

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.directive('mask', {
        mounted(el, binding) {
            if (binding.value == null) return
            loadInputmask().then((InputmaskLib) => {
                if (!el.isConnected) return
                new InputmaskLib(binding.value).mask(el)
            })
        },
        updated(el, binding) {
            if (binding.value == null) return
            loadInputmask().then((InputmaskLib) => {
                if (!el.isConnected) return
                new InputmaskLib(binding.value).mask(el)
            })
        }
    })
})
